export default __webpack_public_path__ + "media/images/react_icons/calendar_plus-4f2cd561583cd427049b63d05dc10d49.svg";